<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="enableDate" type="checkbox" value="{{fieldOptions.validate.laterThanNow}}"
      (ngModelChange)="dataChanged.emit($event)"
      [(ngModel)]="fieldOptions.validate.laterThanNow">
    <span>
      <b>Later than today</b>
    </span>
  </label>
</div>